import { render, staticRenderFns } from "./HomeCover.vue?vue&type=template&id=535b3b3c&scoped=true"
import script from "./HomeCover.vue?vue&type=script&lang=js"
export * from "./HomeCover.vue?vue&type=script&lang=js"
import style0 from "./HomeCover.vue?vue&type=style&index=0&id=535b3b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b3b3c",
  null
  
)

export default component.exports